<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>用户中心</el-breadcrumb-item>
        <el-breadcrumb-item>商城订单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="wrapper">
      <div class="sidebar">
        <div class="avatar">
          <img src="../../assets/images/avatar.jpg" />
          <div class="name">
            <!--<h3>张明翰</h3>-->
            <p>{{ phoneNumShow() }}</p>
          </div>
        </div>
        <ul class="menu">
          <li>
            <router-link to="/account/ticket-order">
              <img src="../../assets/images/icon-ticket.png" />
              <span>票务订单</span>
            </router-link>
          </li>
          <li class="active">
            <router-link to="/account/mall-order">
              <img src="../../assets/images/icon-order-active.png" />
              <span>商城订单</span>
            </router-link>
          </li>
          <li>
            <!--<router-link to="/account/contacts"> @click="goToContacts()"-->
            <router-link to="/account/contacts">
              <img src="../../assets/images/icon-contacts.png" />
              <span>常用联系人</span>
            </router-link>
          </li>
          <!--
          <li>
            <router-link to="/account/profile">
              <img src="../../assets/images/icon-profile.png" />
              <span>个人资料</span>
            </router-link>
          </li>-->
        </ul>
      </div>
      <div class="main">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            v-for="(tabItem, tabIndex) in tabList"
            :key="tabIndex"
            :label="tabItem"
            :name="tabItem"
          >
            <ul class="mall-order-list">
              <li
                v-for="(mallOrderItem, mallOrderIndex) in mallOrderInfo"
                :key="mallOrderIndex"
                @click="goOrderDetail(mallOrderItem.code)"
              >
                <div class="mall-name">
                  <p>
                    {{ mallOrderItem.status_desc }}
                  </p>
                  {{ mallOrderItem.store_name }}
                </div>
                <ul class="order-goods">
                  <li
                    v-for="(goodsItem, goodsIndex) in mallOrderItem.goods"
                    :key="goodsIndex"
                  >
                    <img :src="allImageUrl(goodsItem.goods_img)" />
                    <div class="goods-text">
                      <h3>{{ goodsItem.goods_name }}</h3>
                      <div v-if="goodsItem.spec_qty == 1">
                        <p>
                          {{ goodsItem.spec_info.spec_k1 }}:
                          {{ goodsItem.spec_info.spec_v1 }}
                        </p>
                      </div>
                      <div v-if="goodsItem.spec_qty == 2">
                        <p>
                          {{ goodsItem.spec_info.spec_k1 }}:
                          {{ goodsItem.spec_info.spec_v1 }}
                        </p>
                        <p>
                          {{ goodsItem.spec_info.spec_k2 }}:
                          {{ goodsItem.spec_info.spec_v2 }}
                        </p>
                      </div>
                    </div>
                    <div>¥{{ goodsItem.goods_price }}</div>
                    <div>x {{ goodsItem.goods_num }}</div>
                  </li>
                </ul>
                <div class="order-total">
                  <div class="right-button" v-if="mallOrderItem.status == 0">
                    <span
                      class="btn-gray"
                      @click.stop="deleteOrder(mallOrderItem.code)"
                      >删除订单</span
                    >
                  </div>
                  <div
                    class="right-button"
                    v-if="
                      mallOrderItem.status == 10 || mallOrderItem.status == 11
                    "
                  >
                    <span
                      class="btn-gray"
                      @click.stop="cancelOrder(mallOrderItem.code)"
                      >取消订单</span
                    >
                    <span class="btn-green" @click.stop="goPay(mallOrderItem)"
                      >付款</span
                    >
                  </div>
                  <div class="right-button" v-if="mallOrderItem.status == 20">
                    <!-- <span class="btn-green">提醒发货</span> -->
                  </div>
                  <div class="right-button" v-if="mallOrderItem.status == 30">
                    <span
                      class="btn-green"
                      @click.stop="takeOverOrder(mallOrderItem.code)"
                      >确认收货</span
                    >
                  </div>
                  合计 ￥ {{ mallOrderItem.amount }}
                </div>
              </li>
            </ul>
            <el-pagination
              v-if="mallOrderInfo && mallOrderInfo.length > 0"
              background
              layout="prev, pager, next"
              :page-count="page_total"
              @current-change="currentChange"
            >
            </el-pagination>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog
      title="取消提示"
      :visible.sync="cancelDialogVisible"
      width="30%"
      :before-close="cancelHandleClose"
    >
      <p>您确定要取消该订单么？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="cancelOrderConfirm">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="删除订单提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <p>您确定要删除该订单吗？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="refundOrderConfirm">确定</el-button>
      </span>
    </el-dialog>
    <new-pay-pouup
      :payDialogShow="payQrCode"
      :orderId="order_id"
      :orderAmount="order_amount"
      v-on:payPrenterShow="payPrenterShow"
      comeFrom="mall"
    >
    </new-pay-pouup>
  </div>
</template>

<script>
import mall from '@/api/mall';
import routerTo from '@/router/routerTo';
import { phoneHidden, getImageAllUrl } from '@/setup/common';
import user from '@/setup/user';
import NewPayPouup from '@/components/NewPayPouup';
import { mapState } from 'vuex';
export default {
  components: {
    NewPayPouup,
  },
  data() {
    return {
      activeName: '全部',
      tabList: ['全部', '待付款', '待收货'],
      current: 0,
      loadMoreShow: false,
      dialogVisible: false,
      cancelDialogVisible: false,
      payQrCode: false,
      page: 1,
      mallOrderInfo: [],
      orderCode: '',
      topOrderType: 0,
      page_total: 0,
      loadMore: false,
      order_id: '',
      order_amount: '',
      pageList: [],
    };
  },
  computed: {
    ...mapState({
      isLogin: (state) => state.isLogin,
    }),
    /*
    isLogin() {
      return this.$store.getters.isLogin;
    },*/
  },
  watch: {
    // $toute() {
    //   console.log('路由变化了');
    // },
  },
  mounted() {},
  created() {
    if (!this.isLogin) {
      routerTo.toLogin(this.$router, false);
    } else {
      if (sessionStorage.getItem('comeFrom') == 'submitOrder') {
        this.activeName = '待付款';
        this.topOrderType = 2;
      } else {
        this.activeName = '全部';
        this.topOrderType = 0;
      }
      this.getMallOrderList(this.topOrderType);
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem('comeFrom');
  },
  methods: {
    currentChange(value) {
      this.page = value;
      this.getMallOrderList(this.topOrderType);
    },
    handleClick(tab) {
      this.current = tab.index;
      if (tab.index == 0) {
        this.topOrderType = 0;
        //this.activeName = 0;
      } else if (tab.index == 1) {
        this.topOrderType = 2;
        //this.activeName = 1;
      } else if (tab.index == 2) {
        this.topOrderType = 3;
        //this.activeName = 2;
      }
      this.mallOrderInfo = [];
      this.page = 1;
      this.getMallOrderList(this.topOrderType);
    },
    allImageUrl(string) {
      return getImageAllUrl(string);
    },
    goPay(order) {
      this.order_id = order.code;
      this.order_amount = order.amount;
      this.payQrCode = true;
    },
    deleteOrder(orderCode) {
      this.orderCode = orderCode;
      this.dialogVisible = true;
    },
    refundOrderConfirm() {
      this.getDeleteOrder();
    },
    cancelOrder(orderCode) {
      this.orderCode = orderCode;
      this.cancelDialogVisible = true;
    },
    cancelOrderConfirm() {
      this.getCancelOrder();
    },
    goOrderDetail(code) {
      routerTo.toGoodsDetail(this.$router, false, { orderCode: code });
    },
    async getMallOrderList(status) {
      this.pageList = [];
      const mallOrderList = await mall.getOrderListWithGoods({
        /*product_code:"1005",*/
        order_type_web: status,
        page: this.page,
      });
      this.mallOrderInfo = mallOrderList.order_info;
      this.page_total = mallOrderList.page_total;
      window.scrollTo(0, 0);
    },
    async getDeleteOrder() {
      const DeleteOrder = await mall.getDeleteOrder({
        order_code: this.orderCode,
      });
      this.dialogVisible = false;
      this.getMallOrderList(this.topOrderType);
    },
    async getCancelOrder() {
      const cancelOrder = await mall.getCancelOrder({
        order_code: this.orderCode,
      });
      this.cancelDialogVisible = false;
      this.getMallOrderList(this.topOrderType);
    },
    async getRemindOrder() {
      //提醒发货
      const remind = await mall.getRemindOrder({
        order_code: this.orderCode,
      });
      this.getMallOrderList(this.topOrderType);
    },
    async takeOverOrder(code) {
      const re = await mall.getTakeOverOrder({
        order_code: code,
      });
      alert('确认收货成功');
      this.activeName = '全部';
      this.topOrderType = 0;
      this.getMallOrderList(this.topOrderType);
    },
    handleClose() {
      this.dialogVisible = false;
    },
    cancelHandleClose() {
      this.cancelDialogVisible = false;
    },
    payPrenterShow() {
      this.payQrCode = false;
      //支付完成更新数据
      this.activeName = '全部';
      this.topOrderType = 0;
      this.getMallOrderList(this.topOrderType);
    },
    phoneNumShow() {
      let currentUser = user.getUser();
      if (currentUser != null) {
        let phone = phoneHidden(currentUser.phone);
        return phone;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.wrapper {
  display: flex;
  justify-content: space-between;
  width: 1100px;
  margin: 0 auto;
  padding: 20px 0;
  text-align: left;
}
.sidebar {
  width: 280px;
  padding: 20px 0;
  border-radius: 10px;
  background: #fff;
  .avatar {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 0 30px;
    .name {
      margin-left: 16px;
      h3 {
        margin-bottom: 5px;
        font-size: 18px;
      }
    }
  }
  .menu {
    li {
      height: 50px;
      padding: 0 0 0 30px;
      font-size: 16px;
      line-height: 50px;
      a {
        display: block;
        color: #191b26;
      }
      img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
    }
    li.active {
      border-right: 2px solid #31a775;
      color: #31a775;
      background: #f6fcf9;
      a {
        color: #31a775;
      }
    }
  }
}
.main {
  width: 800px;
  .mall-order-list {
    li {
      margin-bottom: 20px;
      border-radius: 10px;
      line-height: 24px;
      background: #fff;
      cursor: pointer;
      .mall-name {
        padding: 10px 20px;
        border-bottom: 1px solid #eee;
        p {
          float: right;
          img {
            width: 20px;
            height: 20px;
            margin-right: 2px;
          }
        }
      }
      .order-goods {
        padding: 10px 0;
        li {
          display: flex;
          margin-bottom: 0;
          padding: 10px 20px;
          img {
            width: 80px;
            height: 80px;
            margin-right: 20px;
          }
          .goods-text {
            width: 280px;
          }
          h3 {
            margin-bottom: 6px;
            font-weight: normal;
            font-size: 14px;
          }
          div {
            margin-right: 100px;
          }
        }
      }
      .order-total {
        padding: 20px 20px;
        border-top: 1px solid #eee;
        .right-button {
          float: right;
          .btn-green,
          .btn-gray {
            margin-left: 20px;
            padding: 8px 22px;
            border-radius: 16px;
            color: #fff;
            background: #31a775;
            cursor: pointer;
          }
          .btn-gray {
            background: #bbbbbb;
          }
        }
      }
    }
  }
  .order-list {
    li {
      margin-bottom: 20px;
      padding: 20px 20px;
      border-radius: 10px;
      line-height: 24px;
      background: #fff;
      .time {
        display: flex;
        justify-content: space-between;
        margin-bottom: 6px;
        h3 {
          color: #191b26;
          font-weight: normal;
          font-size: 16px;
        }
        p span {
          margin-left: 6px;
          font-size: 20px;
        }
      }
      .number {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        color: #515457;
        .price {
          padding-bottom: 10px;
          span {
            margin-left: 6px;
            color: #f15b49;
            font-size: 20px;
          }
        }
      }
      .status {
        display: flex;
        align-items: center;
        justify-content: space-between;
        a {
          margin-left: 10px;
        }
        .button {
          display: inline-block;
          margin-left: 20px;
          padding: 6px 16px;
          border-radius: 18px;
          color: #fff;
          background: #31a775;
        }
        .completed {
          color: #31a775;
        }
        .unpaid {
          color: #f15b49;
        }
        .cancelled {
          color: #9e9e9e;
        }
        img {
          width: 20px;
          height: 20px;
          margin-right: 2px;
        }
      }
    }
    li:hover {
      box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
      cursor: pointer;
    }
  }
  .pagination {
    margin: 40px 0 20px;
    text-align: center;
    a {
      display: inline-block;
      margin: 0 6px;
      padding: 0 8px;
      border: 1px solid #31a775;
      border-radius: 4px;
      color: #31a775;
      line-height: 22px;
      background: #fff;
    }
    a.active {
      color: #fff;
      background: #31a775;
    }
    a.disable {
      border: 1px solid #ccc;
      color: #fff;
      background: #ccc;
      cursor: default;
    }
  }
}
.main /deep/ .el-pagination {
  padding: 20px 0;
  text-align: center;
}
.main /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #31a775;
}
.main /deep/ .el-tabs__header {
  margin: 0 0 20px;
}
.main /deep/ .el-tabs__item {
  height: 43px;
  border: none;
  color: #515457;
  font-size: 16px;
  line-height: 43px;
}
.main /deep/ .el-tabs__item.is-active {
  color: #31a775;
}
.main /deep/ .el-tabs__item:hover {
  color: #31a775;
}
.main /deep/ .el-tabs__active-bar {
  height: 2px;
  background: #31a775;
}
.main /deep/ .el-tabs__nav-wrap::after {
  height: 1px;
}
</style>
